import { AbstractControl, ValidationErrors } from '@angular/forms'

export function notAllSpacesValidator(control: AbstractControl): ValidationErrors | null {
  return /^\s+$/.test(control.value) ? { allSpaces: true } : null
}
